/**
 * Category preset images — deterministic fallback photos for businesses
 * that have no uploaded cover image.
 *
 * Uses Unsplash URLs with fixed dimensions (800x400, landscape, crop).
 * Each category has 10 preset photos. A business always gets the same photo
 * based on its ID (deterministic via modulo).
 *
 * Usage:
 *   import { getCategoryPresetImage } from '../utils/categoryPresetImages';
 *   const coverUrl = getCategoryPresetImage('beauty-spa', business.id);
 */

const CATEGORY_PRESETS = {
  "beauty-spa": [
    "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1519823551278-64ac92734314?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1540555700478-4be289fbec6d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1470259078422-826894b933aa?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&h=400&fit=crop",
  ],
  healthcare: [
    "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1504813184591-01572f98c85f?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1551076805-e1869033e561?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1666214280557-f1b5022eb634?w=800&h=400&fit=crop",
  ],
  fitness: [
    "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1549060279-7e168fcee0c2?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1593079831268-3381b0db4a77?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=800&h=400&fit=crop",
  ],
  "food-restaurant": [
    "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1552566626-52f8b828add9?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1559339352-11d035aa65de?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1424847651672-bf20a4b0982b?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1567521464027-f127ff144326?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1537047902294-62a40c20a6ae?w=800&h=400&fit=crop",
  ],
  "home-services": [
    "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1585128792020-803d29415281?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1523413363574-c30aa1c2a516?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&h=400&fit=crop",
  ],
  education: [
    "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1577896851231-70ef18881754?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=400&fit=crop",
  ],
  automotive: [
    "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1625047509248-ec889cbff17f?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1530046339160-ce3e530c7d2f?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=800&h=400&fit=crop",
  ],
  pets: [
    "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1450778869180-e77d3c79b66b?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1583337130417-13104dec14c3?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1535930749574-1399327ce78f?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1592194996308-7b43878e84a6?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1544568100-847a948585b9?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1560807707-8cc77767d783?w=800&h=400&fit=crop",
  ],
  events: [
    "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1478147427282-58a87a120781?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1496337589254-7e19d01cec44?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800&h=400&fit=crop",
  ],
  technology: [
    "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1535378917042-10a22c95931a?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1483058712412-4245e9b90334?w=800&h=400&fit=crop",
  ],
  professional: [
    "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1497215842964-222b430dc094?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1504384764586-bb4cdc1707b0?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=400&fit=crop",
  ],
  retail: [
    "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1528698827591-e19cef791f48?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1481437156560-3205f6a55735?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=800&h=400&fit=crop",
  ],
  default: [
    "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1497215842964-222b430dc094?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1504384764586-bb4cdc1707b0?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&h=400&fit=crop",
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=400&fit=crop",
  ],
};

/**
 * Slug normalization — maps common category name variants to preset keys.
 * Handles both slug format ("beauty-spa") and display name ("Beauty & Spa").
 */
const SLUG_ALIASES = {
  "beauty": "beauty-spa",
  "beauty-and-spa": "beauty-spa",
  "beauty & spa": "beauty-spa",
  "beauty_spa": "beauty-spa",
  "spa": "beauty-spa",
  "salon": "beauty-spa",
  "health": "healthcare",
  "medical": "healthcare",
  "clinic": "healthcare",
  "food": "food-restaurant",
  "food-beverage": "food-restaurant",
  "food & beverage": "food-restaurant",
  "food_beverage": "food-restaurant",
  "restaurant": "food-restaurant",
  "cafe": "food-restaurant",
  "bakery": "food-restaurant",
  "home": "home-services",
  "home_services": "home-services",
  "home services": "home-services",
  "repair": "home-services",
  "cleaning": "home-services",
  "plumbing": "home-services",
  "education-training": "education",
  "training": "education",
  "school": "education",
  "tutoring": "education",
  "auto": "automotive",
  "car": "automotive",
  "garage": "automotive",
  "pet": "pets",
  "veterinary": "pets",
  "vet": "pets",
  "event": "events",
  "wedding": "events",
  "party": "events",
  "tech": "technology",
  "it": "technology",
  "software": "technology",
  "consulting": "professional",
  "legal": "professional",
  "law": "professional",
  "accounting": "professional",
  "finance": "professional",
  "shop": "retail",
  "store": "retail",
  "boutique": "retail",
  "fashion": "retail",
  "gym": "fitness",
  "yoga": "fitness",
  "sport": "fitness",
  "sports": "fitness",
};

/**
 * Resolve a category slug/name to a known preset key.
 * @param {string|null|undefined} categorySlugOrName
 * @returns {string} normalized preset key
 */
function resolvePresetKey(categorySlugOrName) {
  if (!categorySlugOrName) return "default";
  const lower = String(categorySlugOrName).toLowerCase().trim();
  // Direct match
  if (CATEGORY_PRESETS[lower]) return lower;
  // Alias match
  if (SLUG_ALIASES[lower]) return SLUG_ALIASES[lower];
  // Partial match — check if any key is contained in the input
  for (const [alias, key] of Object.entries(SLUG_ALIASES)) {
    if (lower.includes(alias)) return key;
  }
  for (const key of Object.keys(CATEGORY_PRESETS)) {
    if (key !== "default" && lower.includes(key)) return key;
  }
  return "default";
}

/**
 * Get a deterministic preset image for a business based on its category and ID.
 *
 * @param {string|null|undefined} categorySlugOrName — category slug, name, or any recognizable variant
 * @param {number|string} businessId — business ID for deterministic selection
 * @returns {string} Unsplash URL for the preset image
 */
export function getCategoryPresetImage(categorySlugOrName, businessId) {
  const key = resolvePresetKey(categorySlugOrName);
  const presets = CATEGORY_PRESETS[key] || CATEGORY_PRESETS["default"];
  const numId = typeof businessId === "number" ? businessId : parseInt(String(businessId), 10) || 0;
  const index = Math.abs(numId) % presets.length;
  return presets[index];
}

/**
 * Get all preset images for a category.
 * @param {string|null|undefined} categorySlugOrName
 * @returns {string[]}
 */
export function getCategoryPresets(categorySlugOrName) {
  const key = resolvePresetKey(categorySlugOrName);
  return CATEGORY_PRESETS[key] || CATEGORY_PRESETS["default"];
}

/**
 * Get all available category preset keys.
 * @returns {string[]}
 */
export function getPresetCategoryKeys() {
  return Object.keys(CATEGORY_PRESETS).filter((k) => k !== "default");
}

export { CATEGORY_PRESETS, resolvePresetKey };
